import { RoleService } from "@js/services/RoleService";
import { Case } from "@src/apis/ModularClient";

export class LandingController {
  caseId: number;
  case: Case;
  disablepayment: boolean = false;
  message: string = "";
  modal: boolean = false;

  static $inject = ["$routeParams", "$scope", "$location", "$cookies", "RoleService"];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $scope: ng.IScope,
    private $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    private roleService: RoleService,
  ) {
    //Check if the user is logged in
    if (this.$cookies.get("access_token") != null || this.$cookies.get("access_token") != undefined) {
      if (this.roleService.isAdminUser) {
        this.$location.path("/dashboard");
      } else {
        this.$location.path("/userdashboard");
      }
    }
  }

  goToLoginPage() {
    this.$location.path("/login");
  }

  goToWelcomePage() {
    this.$location.path("/landingV3");
  }

  goToAgentLandingPage() {
    this.$location.path("/agentlanding");
  }
}
